<template>
  <div class="grid w-full grid-cols-1 gap-8 lg:grid-cols-3">
    <div
      v-for="(tool, index) in tools"
      :key="index"
      class="flex h-full w-full flex-col overflow-hidden rounded-2xl border border-[#eaecf0] bg-[linear-gradient(180deg,_#FCFCFD_0%,_#F9FAFB_100%)] lg:min-h-[400px]"
    >
      <div class="flex flex-col gap-1 p-6">
        <h1 class="text-2xl font-medium text-[#101828]">
          {{ tool.name }}
        </h1>
        <p class="text-base text-[#344054]">
          {{ tool.description }}
        </p>
      </div>
      <img
        :src="tool.image"
        alt="tool-img"
        class="h-40 w-full flex-1 object-cover sm:h-[244px]"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { shallowRef } from "vue";
import Variables from "@/../images/tabbed-bento-images/variables/variables.svg";
import Preview from "@/../images/tabbed-bento-images/variables/preview.svg";
import SetUpImage from "@/../images/tabbed-bento-images/variables/set-up.svg";

const tools = shallowRef([
  {
    name: "Variables",
    description: "Layers provide freedom to experiment with text, images, or shapes. Explore various arrangements to find your perfect balance.",
    image: Variables,
  },
  {
    name: "Preview",
    description:
      "Experiment with fonts, sizes, and colors to achieve the perfect look every time with our user-friendly editor. Your text, your way!",
    image: Preview,
  },
  {
    name: "Easy to set up",
    description: "Adjust your postcard's text by selecting or creating boxes. Add a personal touch to your design.",
    image: SetUpImage,
  },
]);
</script>
